import { Slide } from "react-toastify";

export const TOAST_CONTAINER_CONFIG = {
  autoClose: 3000,
  hideProgressBar: true,
  newestOnTop: false,
  closeOnClick: false,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: false,
  pauseOnHover: true,
  transition: Slide,
};
